define([
    'santa-components',
    'zepto',
    'lodash',
    'react',
    'create-react-class',
    'componentsCore',
    'coreUtils',
    'expandableMenu/components/expandableMenuItem',
    'expandableMenu/utils/expandableMenuUtils',
    'reactDOM',
    'skins',
    'expandableMenu/skins/skins.json'
], function (
    santaComponents,
    $,
    _,
    React,
    createReactClass,
    componentsCore,
    coreUtils,
    expandableMenuItem,
    expandableMenuUtils,
    ReactDOM,
    skinsPackage,
    skinsJson
) {
    'use strict';

    const cmp = createReactClass(expandableMenuItem);
    const expandableMenuItemInstance = React.createElement.bind(null, cmp);
    expandableMenuItemInstance.type = cmp;

    const getLIParent = node => {
        while (node.tagName !== 'LI') {
            node = node.parentElement;
        }

        return node;
    };

    const expandableMenu = {
        displayName: 'ExpandableMenu',
        mixins: [
            componentsCore.mixins.skinBasedComp,
            componentsCore.mixins.skinInfo,
            componentsCore.mixins.createChildComponentMixin
        ],
        propTypes: _.assign({
            id: santaComponents.santaTypesDefinitions.Component.id.isRequired,
            isMobileView: santaComponents.santaTypesDefinitions.isMobileView.isRequired,
            menuItems: santaComponents.santaTypesDefinitions.Menu.menuItems,
            currentUrlPageId: santaComponents.santaTypesDefinitions.Component.currentUrlPageId.isRequired,
            closeInlinePopup: santaComponents.santaTypesDefinitions.InlinePopup.close,
            rootNavigationInfo: santaComponents.santaTypesDefinitions.Component.rootNavigationInfo,
            componentPreviewState: santaComponents.santaTypesDefinitions.RenderFlags.componentPreviewState,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            isMeshLayoutMechanism: santaComponents.santaTypesDefinitions.Layout.isMeshLayoutMechanism,
            componentViewMode: santaComponents.santaTypesDefinitions.RenderFlags.componentViewMode,
            registerReLayoutPending: santaComponents.santaTypesDefinitions.Layout.registerReLayoutPending.isRequired,
            styleId: santaComponents.santaTypesDefinitions.Component.styleId,
            skin: santaComponents.santaTypesDefinitions.Component.skin,
            style: santaComponents.santaTypesDefinitions.Component.style,
            isResponsive: santaComponents.santaTypesDefinitions.RendererModel.isResponsive,
            getTranslatedAriaLabel: santaComponents.santaTypesDefinitions.Accessibility.getTranslatedAriaLabel.isRequired
        }),

        statics: {
            // height is passed as props to children slides
            compSpecificIsDomOnlyOverride: (prevProps, nextProps) => nextProps.style.height === prevProps.style.height
        },
        onMouseClick(event) {
            const clickedAnArrow = _.includes(event.target.className, 'arrow'); //event.target.className.indexOf('arrow') !== -1;
            const liParent = getLIParent(event.target);
            const $liParent = $(liParent);
            const isFolder = $liParent.hasClass(`${this.props.styleId}_noLink`);

            if (clickedAnArrow || isFolder) {
                event.preventDefault(); // do not navigate
                event.stopPropagation();

                const collapseId = liParent.id;
                const isAlreadyExpanded = !!this.state.expandedMenus[collapseId];
                if (isAlreadyExpanded) {
                    this.closeSubMenu(collapseId);
                } else {
                    this.openSubMenu(collapseId);
                }
            }
        },

        registerLayoutIfNotMesh() {
            if (!this.props.isMeshLayoutMechanism) {
                this.props.registerReLayoutPending(this.props.id);
            }
        },

        openSubMenu(collapseId) {
            const expandedMenus = _.assign({}, this.state.expandedMenus, {[collapseId]: true});
            this.setState({expandedMenus});
            this.saveLastClickedMenu(collapseId);
            this.registerLayoutIfNotMesh();
        },

        closeAllMenusAndOpenSingleMenu(collapseId) {
            const expandedMenus = {[collapseId]: true};
            this.setState({expandedMenus});
            this.registerLayoutIfNotMesh();
        },

        openFirstSubMenu() {
            const domNode = ReactDOM.findDOMNode(this);
            const itemWithSubListSelector = `.${this.props.styleId}_hasSubList`;
            const firstSubMenuIdToOpen = _.get(_.head($(domNode).find(itemWithSubListSelector)), 'id');
            this.openSubMenu(firstSubMenuIdToOpen);
        },

        closeAllSubMenus() {
            const expandedMenus = {};
            this.setState({expandedMenus});
        },

        closeSubMenu(collapseId) {
            const expandedMenus = _.omit(this.state.expandedMenus, collapseId);
            this.setState({expandedMenus});
            this.saveLastClickedMenu(collapseId);
            this.registerLayoutIfNotMesh();
        },

        getInitialState() {
            return {
                $itemsAlignment: `items-align-${this.props.compProp.itemsAlignment}`,
                $arrowDirection: `arrow-direction-${this.props.compProp.menuArrowDirection || 'right'}`,
                lastClickedMenu: undefined,
                expandedMenus: {}
            };
        },
        componentWillReceiveProps(nextProps) {
            const itemAlignmentChanged = nextProps.compProp.itemsAlignment !== this.props.compProp.itemsAlignment ||
                nextProps.compProp.menuArrowDirection !== this.props.compProp.menuArrowDirection;

            const comingBackFromPreview = !_.isEqual(nextProps.componentViewMode, this.props.componentViewMode);

            if (itemAlignmentChanged) {
                this.setState({
                    $itemsAlignment: `items-align-${nextProps.compProp.itemsAlignment}`,
                    $arrowDirection: `arrow-direction-${nextProps.compProp.menuArrowDirection}`
                });
            }

            if (comingBackFromPreview) {
                this.closeAllSubMenus();
            }
            if (this.props.componentPreviewState) {
                this.openFirstSubMenu();
            } else {
                this.closeAllSubMenus();
            }

            const parentItemWithSelectedChild = _(nextProps.compData.menuRef.items)
                .filter(item => expandableMenuUtils.isVisible(item, this.props.isMobileView))
                .find(item => _.some(item.items, subItem => _.get(subItem, ['link', 'pageId', 'id']) === nextProps.currentUrlPageId));
            const parentItemPageId = _.get(parentItemWithSelectedChild, ['link', 'pageId', 'id']);

            if (parentItemPageId) {
                this.openSubMenuByPageId(parentItemPageId);
            }
        },
        openSubMenuByPageId(pageId) {
            const domNode = ReactDOM.findDOMNode(this);
            const li = $(domNode).find(`[data-page-id="${pageId}"]`);
            const collapseId = _.get(li, ['0', 'id']);
            if (collapseId) {
                this.closeAllMenusAndOpenSingleMenu(collapseId);
            }
        },
        updateDOMDataAttributes() {
            const domNode = ReactDOM.findDOMNode(this);
            const params = this.getParamValues();
            this.lastParams = params;
            domNode.setAttribute('data-param-border', params.border);
            domNode.setAttribute('data-param-separator', params.separator);
            domNode.setAttribute('data-param-padding', params.padding);
        },
        saveLastClickedMenu(collapseId) {
            this.setState({lastClickedMenu: collapseId});
        },
        focusLastClickedMenu() {
            const {lastClickedMenu} = this.state;
            if (!lastClickedMenu) {
                return;
            }
            const arrow = this.getArrowNode(lastClickedMenu);
            if (!arrow) {
                return;
            }
            arrow.focus();
        },
        componentDidMount() {
            this.updateDOMDataAttributes();
        },
        componentDidUpdate() {
            if (!_.isEqual(this.getParamValues(), this.lastParams)) {
                this.updateDOMDataAttributes();
            }
            if (this.props.isExperimentOpen('bv_accessibilityMobileMenuArrowFix')) {
                this.focusLastClickedMenu();
            }
        },
        getParamValues() {
            const separatorParam = this.getParamFromDefaultSkin('separatorHeight') || this.getParamFromDefaultSkin('sepw');
            const paddingParam = this.getParamFromDefaultSkin('textSpacing');
            const borderParam = this.getParamFromDefaultSkin('brw');

            return {
                separator: separatorParam ? parseInt(separatorParam.value, 10) : 0,
                border: borderParam ? parseInt(borderParam.value, 10) : 0,
                padding: paddingParam ? parseInt(paddingParam.value, 10) : 0
            };
        },

        getAriaLabel() {
            const MENU_ARIA_LABEL_KEY = 'dropDownMenu_AriaLabel_TopLevel_SiteNavigation';
            return this.props.getTranslatedAriaLabel('AriaLabels', MENU_ARIA_LABEL_KEY, 'Site');
        },

        getArrowNode(collapseId) {
            const domNode = ReactDOM.findDOMNode(this);
            const menu = domNode.querySelector(`#${collapseId}`);
            const isNoLink = /_noLink/.test(menu.className);
            const inertElementSelector = isNoLink ? '.level0' : '[class$=_arrow]';
            return menu.querySelector(inertElementSelector);
        },

        getSkinProperties() {
            const params = this.getParamValues();
            const skinExports = this.getSkinExports();
            const menuItems = this.props.menuItems;
            const itemHeight = this.props.compProp.menuItemHeight || 0;

            return {
                '': {
                    tagName: 'nav',
                    'aria-label': this.getAriaLabel()
                },
                menuContainer: {
                    parentConst: expandableMenuItemInstance,
                    data: menuItems,
                    skin: this.props.skin,
                    classPrefix: this.props.styleId,
                    currentUrlPageId: this.props.currentUrlPageId, // for aria
                    isMobileView: this.props.isMobileView,
                    isResponsive: this.props.isResponsive,
                    heights: {
                        separator: skinExports && skinExports.separatorNotIncludedInLineHeight ? 0 : params.separator,
                        line: coreUtils.verticalMenuCalculations.getLineHeight(itemHeight, params.separator, params.border, skinExports),
                        item: itemHeight
                    },
                    callbacks: {
                        click: this.onMouseClick
                    },
                    expandedMenus: this.state.expandedMenus,
                    counterClassName: 'counter', // TODO: product decision about counter from vertical menu? idanC
                    itemsAlignment: this.props.compProp.itemsAlignment
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.ExpandableMenu', expandableMenu);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return expandableMenu;
});
